import { ref, type Ref } from 'vue';

// Shared reactive ref for cross-component tab switching.
// Any component can write to this, and any tab component can watch it.
const activeTabOverride: Ref<string | null> = ref(null);

/**
 * Request a tab switch from any component (e.g., ButtonViews, EngagementBar).
 */
export const useActiveTabTrigger = () => {
  const requestTab = (tab: string) => {
    activeTabOverride.value = tab;
  };

  return { requestTab };
};

/**
 * Watch for external tab switch requests in tab components.
 */
export const useActiveTabListener = () => {
  return { activeTabOverride };
};
